import React, { useState } from "react";
import { Button, Form, Input, Modal, Spin, message } from "antd";
import { orderUpdate } from "../../Services/Services";
import { EditOutlined } from "@ant-design/icons";
const FreightPaymentRegisterUpdate = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  if (props.filterOrder) {
    form.setFieldsValue(props.filterOrder);
  }
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const onFinish = async (values) => {
    setLoading(true);
    Object.assign(values, { com_name: localStorage.getItem("com_name") });
    const response = await orderUpdate(props.filterOrder.id, values);
    setLoading(false);
    if (Array.isArray(response)) {
      message.success("Freight Update Successful");
      const sortedArray = [...response].sort((a, b) => b.id - a.id);
      props.setDeliveryOrder(sortedArray);
      props.setorderList(sortedArray);
      setIsModalOpen(false);
      form.resetFields();
    } else {
      message.warning(response.errors);
    }
  };

  return (
    <>
      <Modal open={loading} footer={null} closable={false} width={400}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src="transduniyalogo.png"
            alt="img"
            width={200}
            style={{ margin: "10px" }}
          />

          <Spin />
          <h2>Freight Details Updating......</h2>
        </div>
      </Modal>
      <Button
        onClick={showModal}
        style={{
          border: "none",
          background: "transparent",
          cursor: "pointer",
          padding: "8px",
          fontSize: "18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <EditOutlined
          style={{ fontSize: "20px", color: "black", padding: "2px" }}
        />
      </Button>
      <Modal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            name="aadhar_no"
            label={<b>Aadhar No</b>}
            style={{ padding: "0px", margin: "1px" }}
          >
            <Input placeholder="Aadhar No" maxLength={12} />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Please Enter Check No!",
              },
            ]}
            name="check_no"
            label={<b>Check No</b>}
            style={{ padding: "0px", margin: "1px" }}
          >
            <Input placeholder="Check No" maxLength={15} />
          </Form.Item>

          <Form.Item
            rules={[
              {
                required: true,
                message: "Please Enter Check Date!",
              },
            ]}
            name="check_date"
            label={<b>Check Date</b>}
            style={{ padding: "0px", margin: "1px" }}
          >
            <Input placeholder="Check Date" type="date" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Please Enter Bank Name!",
              },
            ]}
            name="bank_name"
            label={<b>Bank Name</b>}
            style={{ padding: "0px", margin: "1px" }}
          >
            <Input placeholder="Bank Name" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Please Enter ISFC Code!",
              },
            ]}
            name="ifsc_code"
            label={<b>ISFC Code</b>}
            style={{ padding: "0px", margin: "1px" }}
          >
            <Input placeholder="ISFC Code" />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: "Please Enter Account No!",
              },
            ]}
            name="account_no"
            label={<b>Account No</b>}
            style={{ padding: "0px", margin: "1px" }}
          >
            <Input placeholder="Account No" />
          </Form.Item>
          <Form.Item
            className="text-center"
            style={{ textAlign: "center", padding: "0px", margin: "2px" }}
          >
            <Button
              htmlType="submit"
              style={{ color: "white", backgroundColor: "black" }}
            >
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default FreightPaymentRegisterUpdate;
